const getOrderLineDateOfDelivery = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine) {
      if (indexOrderLine.Driver && indexOrderLine.Driver.ID) {
        return `${indexOrderLine.Driver['First Name']} ${indexOrderLine.Driver['Last Name']}`;
      }
      return indexOrderLine.driverName;
    }

    return null;
  }
  return orderLine
    ? orderLine.map((item) => {
      if (item.Driver && item.Driver.ID) {
        return `${item.Driver['First Name']} ${item.Driver['Last Name']}`;
      }
      return item.driverName;
    }).join(', ')
    : null;
};

export default getOrderLineDateOfDelivery;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineDriverFullName.js